import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { CheckCircleIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import { servisers } from '../../data/servisers';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
export function ServisRequestForm() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Zahtev za servis - D-TECH Solutions',
      from_name: 'D-TECH sajt - servis',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
        if (typeof (window as any).gtag === 'function') {
          ;
          (window as any).gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0,
            lead_source: 'service_request'
          });
        }
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз.' : 'Slanje nije uspelo. Pokušajte ponovo.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз.' : 'Greška u mreži. Pokušajte ponovo.');
    }
  };
  if (submitSuccess) {
    return <div className="text-center py-8" data-id="element-602" data-mp="24uvlw6h6a0hs">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-603" data-mp="24t2g0tedvkau">
          <CheckCircleIcon className="w-8 h-8 text-white" data-id="element-604" data-mp="1ztpucbz90j9u" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-605" data-mp="1uykbxn521mqi">
          {en ? 'Service request sent!' : ru ? 'Запрос на обслуживание отправлен!' : 'Zahtev za servis je poslat!'}
        </h3>
        <p className="text-gray-400" data-id="element-606" data-mp="1e8uqvgi56m3">
          {en ? 'Our service team will contact you shortly.' : ru ? 'Наша сервисная служба свяжется с вами в ближайшее время.' : 'Naša servisna služba će vas kontaktirati u najkraćem roku.'}
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" noValidate data-id="element-607" data-mp="fejkfv62sf5o">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-608" data-mp="fbnmw7y53shr">
        <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your full name' : ru ? 'Ваше полное имя' : 'Vaše ime i prezime'} data-id="element-609" data-mp="3euq1htr8muwb" />
        <Input label={en ? 'Company name' : ru ? 'Название компании' : 'Naziv firme'} type="text" name="Naziv_firme" placeholder={en ? 'Company name (optional)' : ru ? 'Название компании (необязательно)' : 'Naziv firme (opciono)'} data-id="element-610" data-mp="2v5fpoqum4u3h" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-611" data-mp="11km3oe5c0rfj">
        <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 ...'} data-id="element-612" data-mp="1ffeptvfq95v3" />
        <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas@email.com' : 'vas@email.com'} data-id="element-613" data-mp="1pe483pbjcsbv" />
      </div>

      <Input label={en ? 'City / District *' : ru ? 'Город / Округ *' : 'Grad / Okrug *'} type="text" name="Grad" required placeholder={en ? 'Your city or district' : ru ? 'Ваш город или округ' : 'Vaš grad ili okrug'} data-id="element-614" data-mp="1uc5rkbcvitnv" />

      <Select label={en ? 'Preferred servicer (optional)' : ru ? 'Предпочитаемый сервис-инженер (необязательно)' : 'Željeni serviser (opciono)'} name="Zeljeni_serviser" defaultValue="" options={[{
      value: '',
      label: en ? 'No preference — assign closest' : ru ? 'Без предпочтений — назначить ближайшего' : 'Bez preferencije — dodelite najbližeg'
    }, ...servisers.map(s => ({
      value: s.id,
      label: `${ru && s.nameRu ? s.nameRu : s.name} — ${en && s.regionEn ? s.regionEn : ru && s.regionRu ? s.regionRu : s.region}`
    }))]} data-id="element-615" data-mp="3q04h0r70m2jo" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-616" data-mp="rgnvrenvnczh">
        <Input label={en ? 'Device model *' : ru ? 'Модель устройства *' : 'Model uređaja *'} type="text" name="Model_uredjaja" required placeholder={en ? 'e.g. D-TECH SCA' : ru ? 'напр. D-TECH SCA' : 'npr. D-TECH SCA'} data-id="element-617" data-mp="wh34tu14lybn" />
        <Input label={en ? 'Serial number' : ru ? 'Серийный номер' : 'Serijski broj'} type="text" name="Serijski_broj" placeholder={en ? 'If known' : ru ? 'Если известно' : 'Ako vam je poznat'} data-id="element-618" data-mp="g46wx2xuxj27" />
      </div>

      <Textarea label={en ? 'Description of the problem *' : ru ? 'Описание проблемы *' : 'Opis problema / kvara *'} name="Opis_problema" required placeholder={en ? 'Please describe the issue in detail...' : ru ? 'Пожалуйста, подробно опишите проблему...' : 'Molimo vas da detaljno opišete problem...'} rows={4} data-id="element-619" data-mp="140celodjnz18" />

      {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-620" data-mp="241g5u61ar5dz">
          {submitError}
        </div>}

      <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-621" data-mp="2dzn8rkyr3mwz">
        {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Slanje...' : en ? 'Send service request' : ru ? 'Отправить запрос на обслуживание' : 'Pošalji zahtev za servis'}
      </Button>
    </form>;
}